import { Button, Form, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../apis/store";
import { showNotitfication } from "../../utils/Utils";
import { normalizeLoginIdentifier, isValidLoginIdentifier } from "../../utils/normalizeLoginIdentifier";
import Register from "./Register";
import { toResetPasswordRequest } from "../../apis/actions/auth.actions";
import {
  AuthIconArrowForward,
  AuthIconUser,
} from "../../Components/icons/AuthFormIcons";
import ResetPasswordOtp from "./ResetPasswordOtp";
interface Props {
  setTorResetPassword: () => void;
}

const ForgotPassword = ({ setTorResetPassword }: Props) => {
  const [loading, setLoading] = useState(false);
  const [toRegister, setToRegister] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [normalizedLogin, setNormalizedLogin] = useState("");
  const [time_left, setTimeLeft] = useState(0);

  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.startsWith("ar");
  const [form] = Form.useForm();
  const handleCloseOtpModal = () => {
    setIsModalVisible(false);
  };
  const onFinish = async () => {
    setLoading(true);
    try {
      await form.validateFields();

      const login = normalizeLoginIdentifier(form.getFieldValue("login"));
      setNormalizedLogin(login);

      const success = (await dispatch(
        toResetPasswordRequest({
          data: { login },
          lang: i18n.language,
        })
      )) as any;

      const RequestReset_password = success?.payload?.data?.result;

      if (RequestReset_password?.code === 200) {
        setIsModalVisible(true);
        setPhoneNumber(RequestReset_password?.phone);
        setTimeLeft(RequestReset_password?.time_left);
        setLoading(false);
      } else if (
        RequestReset_password?.code == 401 &&
        RequestReset_password?.time_left
      ) {
        setIsModalVisible(true);
        setTimeLeft(RequestReset_password?.time_left);
        setPhoneNumber(RequestReset_password?.phone);
        setLoading(false);
      } else {
        showNotitfication(
          i18n.language === "ar"
            ? "لا يمكن إعادة تعيين كلمة السر. يرجى التأكد من المعلومات المدخلة وإعادة المحاولة."
            : "Cannot reset the password. Please check the entered information and try again.",
          "error"
        );
        setLoading(false);
      }
    } catch (error) {
      showNotitfication(
        i18n.language === "ar"
          ? "عذرًا، حدث خطأ أثناء طلب إعادة تعيين كلمة المرور. يُرجى المحاولة مرة أخرى لاحقًا."
          : "Sorry, an error occurred while requesting a password reset. Please try again later.",
        "error"
      );
    }
    setLoading(false);
  };

  return (
    <div className="ac-forgot-password-root">
      <div className="row justify-content-center ac-login-page__grid">
        {toRegister ? (
          <Register setToRegister={() => setToRegister(false)} />
        ) : (
          <div className="col-xxl-6 col-xl-7 col-lg-9 ac-login-page__form-col">
            <div className="ac-login-card">
              <div className="login-content">
                <div className="text-center ac-login-card__head">
                  <span className="ac-login-card__badge ac--font-expo text-sm-bold">
                    {t("forgotPassword.resetPassword")}
                  </span>
                  <h4 className="neutral-1000 ac--font-expo ac-login-card__title">
                    {t("forgotPassword.enterEmail")}
                  </h4>
                </div>
                <div className="form-login mt-30">
                  <Form
                    form={form}
                    onFinish={onFinish}
                    className="ac-login-form"
                  >
                    <Form.Item
                      label=""
                      name="login"
                      rules={[
                        {
                          required: true,
                          message: t("profile.messages.7"), // Keep existing required message
                        },
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();

                            if (isValidLoginIdentifier(value)) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              isRtl
                                ? "يرجى إدخال بريد إلكتروني أو رقم هاتف صحيح"
                                : "Please enter a valid email address or phone number"
                            );
                          },
                        },
                      ]}
                    >
                      <div className="form-group ac--font-expo">
                        <Input
                          className="ac--input-login"
                          size="large"
                          placeholder={t("login.emailOrPhone")}
                          prefix={<AuthIconUser />}
                        />
                      </div>
                    </Form.Item>

                    <div className="mb-4">
                      <p className="text-sm-medium neutral-500 text-center mt-3 ac--font-expo">
                        {t("forgotPassword.sendResetLink")}
                      </p>
                    </div>
                    <div className="form-group mb-30">
                      <Button
                        className="btn btn-primary w-100 ac--font-expo ac-login-page__submit"
                        htmlType="submit"
                        disabled={loading}
                        loading={loading}
                      >
                        {loading === true ? t("btn.loading") : t("btn.send")}
                        <span
                          className={`ac-auth-arrow-slot ${
                            isRtl ? "ac-auth-arrow--rtl" : ""
                          }`}
                        >
                          <AuthIconArrowForward size={17} />
                        </span>
                      </Button>
                    </div>
                  </Form>
                </div>
                <p className="text-sm-medium neutral-1000 text-center mt-30 ac--font-expo mb-0">
                  <button
                    type="button"
                    className="ac-login-page__forgot-btn text-sm-medium"
                    onClick={() => setTorResetPassword()}
                  >
                    {t("forgotPassword.backToSignIn")}
                  </button>
                  <span className="neutral-500 mx-2" aria-hidden>
                    ·
                  </span>
                  {t("login.register")}
                  <button
                    type="button"
                    className="ac-login-page__register-link border-0 bg-transparent p-0 ms-1"
                    onClick={() => setToRegister(true)}
                  >
                    {t("login.register.here")}
                  </button>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <ResetPasswordOtp
        onClose={handleCloseOtpModal}
        open={isModalVisible}
        name={normalizedLogin || normalizeLoginIdentifier(form.getFieldValue("login"))}
        phone={phoneNumber}
        OtpTimeLeft={time_left}
      />
    </div>
  );
};

export default ForgotPassword;
